import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/calendar/calendar-cell.component.js'

const tagName = 'dap-ds-calendar-cell'

/**
 * `dap-ds-calendar-cell`
 * @summary Calendar cell represents a single cell in the calendar.
 * @element dap-ds-calendar-cell
 * @title - Calendar cell
 * @group calendar
 *
 * @slot - The content of the calendar cell.
 *
 * @csspart base - The main calendar cell container.
 * @csspart today-mark - The today mark of the calendar cell.
 *
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCalendarCell',
})

export default reactWrapper
